import { Injectable } from '@angular/core';
import { Geolocation } from '@ionic-native/geolocation';
// import { PN } from './pan';
// import { Vehicles } from './vehicles';
import * as moment from 'moment';
import { GN } from './gn';


declare var google;
declare var RichMarker;
declare var RichMarkerPosition;
declare var ol;

@Injectable()

export class PNMaps {
    mapLive: any;

    mapPOI: any;
    markerPOI: any;
    pinMarker: any;
    circlePOI: any;

    vehicles = []
    markers: any = [];

    socketEnable: any = false;
    VehicleAnim = [];
    VehiclesDic = [];

    moveInterval: any
    isInInterval: boolean = false
    intervalUnderMouse = 0
    isPozWatching = false;
    isMyPozOK = false

    constructor(public pan: GN, private geolocation: Geolocation) {

    }

    getMapOptions() {
        return {
            zoom: 17,
            maxZoom: 18,
            mapTypeControl: true,
            mapTypeControlOptions: {
                style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                position: google.maps.ControlPosition.RIGHT_BOTTOM,
                mapTypeIds: [
                    google.maps.MapTypeId.ROADMAP,
                    google.maps.MapTypeId.HYBRID
                ]
            },
            clickableIcons: false,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            },
            scaleControl: false,
            streetViewControl: false,
            fullscreenControl: false,
        }
    }

    loadMapLive(nativeElement) {
        var _that = this;
        var bounds = new google.maps.LatLngBounds();
        let mapOptions = this.getMapOptions()
        this.mapLive = new google.maps.Map(nativeElement, mapOptions);
        // var latLng = new google.maps.LatLng(42.003462, 21.413276);
        // this.mapLive.setCenter(latLng);
        // this.mapLive.setZoom(8)

        google.maps.event.addListener(this.mapLive, 'idle', function () {
            if (_that.socketEnable == false) { _that.socketEnable = true; }
        });
    }

    addMarkersOnMapLive(_cb: any) {
        for (let k = 0; k < this.markers.length; k++) {
            this.markers[k].setMap(null);
        }
        this.markers = [];
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < this.pan.Vehicles.length; i++) {
            if (this.pan.Vehicles[i].visible + '' == '1') {
                let latLng = new google.maps.LatLng(this.pan.Vehicles[i].lat, this.pan.Vehicles[i].lon);
                this.markers.push(this.addMarker(this.pan.Vehicles[i].code, this.pan.Vehicles[i].lon, this.pan.Vehicles[i].lat, this.pan.Vehicles[i].vehid, this.pan.Vehicles[i].ignition, this.pan.Vehicles[i].status, this.pan.Vehicles[i].color));
                this.VehicleAnim.push()
                this.VehicleAnim.push({ code: this.pan.Vehicles[i].code, lon: this.pan.Vehicles[i].lon, lat: this.pan.Vehicles[i].lat, marker: this.markers[i], anim: [] })

                bounds.extend(latLng);
            }

        }

        for (let j = 0; j < this.markers.length; j++) {
            this.markers[j].setMap(this.mapLive);
        }
        this.mapLive.fitBounds(bounds);      //auto-zoom
        this.mapLive.panToBounds(bounds); //auto-center

        _cb();

    }

    getDriverPosition(_cb: any) {
        var _lon = 21.413276;
        var _lat = 42.003462;

        var options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };
        var _that = this

        if (this.pan.isApp == false) {
            if (location.origin.indexOf('localhost') > -1) {
                _lon = parseFloat('21.424568')
                _lat = parseFloat('41.997988')
                _that.isMyPozOK = true;
                _cb(_lat, _lon, _that.isMyPozOK);
            } else {
                if (navigator.geolocation) {

                    navigator.geolocation.getCurrentPosition(function (_poz) {
                        console.log(_poz.coords)
                        _lon = parseFloat(_poz.coords.longitude + '');
                        _lat = parseFloat(_poz.coords.latitude + '');
                        _that.isMyPozOK = true;
                        _cb(_lat, _lon, _that.isMyPozOK);
                    }, function (_error) {
                        _that.isMyPozOK = false
                        console.log('Error getting location');
                        console.log(_error);

                        const toast = _that.pan.toastCtrl.create({
                            message: _that.pan.dic.l['locationserviceerror'],
                            duration: 3000,
                            position: 'top'
                        });
                        toast.present();
                    }, options);
                } else {
                    this.pan._Post("https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyDvzykDlkODU9QONJbbbCKKy-T6WwJgdrU", {}, function (_data) {
                        _lon = parseFloat(_data.location.lng);
                        _lat = parseFloat(_data.location.lat);
                        _that.isMyPozOK = true
                        _cb(_lat, _lon, _that.isMyPozOK);
                    })
                }
            }
        } else {
            this.geolocation.getCurrentPosition({ enableHighAccuracy: true }).then((resp) => {
                // resp.coords.latitude
                // resp.coords.longitude
                _lon = parseFloat(resp.coords.longitude + '');
                _lat = parseFloat(resp.coords.latitude + '');
                _that.isMyPozOK = true
                _cb(_lat, _lon, _that.isMyPozOK);

                if (_that.isPozWatching == false) {
                    _that.geolocation.watchPosition({ enableHighAccuracy: true }).subscribe(position => {
                        console.log('Vleze vo Watch position')
                        console.log(position)
                        if (position == null) { _that.isMyPozOK = false; return }
                        if (position.coords == null) { _that.isMyPozOK = false; return }
                        if (position.coords.longitude == null) { _that.isMyPozOK = false; return }
                        _that.isMyPozOK = true
                        _lon = parseFloat(position.coords.longitude + '');
                        _lat = parseFloat(position.coords.latitude + '');
                        _cb(_lat, _lon, _that.isMyPozOK);
                    });
                    _that.isPozWatching = true
                }
                // });
            }).catch((error) => {
                _that.isMyPozOK = false
                console.log('Error getting location');
                console.log(error);

                const toast = _that.pan.toastCtrl.create({
                    message: _that.pan.dic.l['locationserviceerror'],
                    duration: 3000,
                    position: 'top'
                });
                toast.present();
            });
        }
    }
    loadMapPOI(nativeElement, _cb: any) {

        console.log('vleze vo loadMapPOI')
        console.log('loadMapPOI ' + this.mapPOI)
        console.log('loadMapPOI ' + this.pan.isApp)

        if (this.mapPOI == null) {
            let mapOptions = this.getMapOptions()
            this.mapPOI = new google.maps.Map(nativeElement, mapOptions);
            var latLng = new google.maps.LatLng(41, 21);
            this.mapPOI.setCenter(latLng);
            this.mapPOI.setZoom(17);
            // this.markerPOI = new google.maps.Marker({
            //     position: latLng,
            //     map: this.mapPOI,
            //     icon: {
            //         path: google.maps.SymbolPath.CIRCLE,
            //         scale: 8.5,
            //         fillOpacity: 1,
            //         fillColor: "#335BFF",
            //         strokeColor: "#FFFFFF",
            //         strokeWeight: 0.5
            //     },
            // });

            this.markerPOI = new RichMarker({
                position: new google.maps.LatLng(41, 21),
                map: this.mapPOI,
                draggable: false,
                content: '<div style="border-radius: 50%; width: 20px; height: 20px; background: #335BFF; border: 1px solid #FFFFFF;" class="pulseV"></div>',
                anchor: RichMarkerPosition.MIDDLE,
                // ready_: true
            });


            this.pinMarker = new RichMarker({
                position: new google.maps.LatLng(41, 21),
                map: this.mapPOI,
                draggable: false,
                content: '<img src="assets/imgs/newpin-red.png" style="left:6px; height:40px; position:relative; top:-15px"/>',
                anchor: RichMarkerPosition.MIDDLE,
                // ready_: true
            });

            var _that2 = this
            google.maps.event.addListener(this.mapPOI, 'center_changed', function () {
                var latlng = new google.maps.LatLng(parseFloat(_that2.mapPOI.getCenter().lat()), parseFloat(_that2.mapPOI.getCenter().lng()));
                _that2.pinMarker.setPosition(latlng);
                _cb();
            });
        }



        var _lon = 21.413276;
        var _lat = 42.003462;

        var options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };
        var _that = this
        // if (navigator.geolocation) {

        if (this.pan.isApp == false) {
            if (location.origin.indexOf('localhost') > -1) {
                _lon = parseFloat(parseFloat('21.424568') + '');
                _lat = parseFloat(parseFloat('41.997988') + '');
                var latLng = new google.maps.LatLng(_lat, _lon);
                _that.markerPOI.setPosition(latLng);
                _that.pinMarker.setPosition(latLng);
                _that.mapPOI.setCenter(latLng);
                _that.mapPOI.setZoom(17);
                _that.isMyPozOK = true
                // let mapOptions = _that.getMapOptions()
                // _that.mapPOI = new google.maps.Map(nativeElement, mapOptions);
                // var latLng = new google.maps.LatLng(_lat, _lon);
                // _that.mapPOI.setCenter(latLng);
                // _that.mapPOI.setZoom(17);
                // _that.markerPOI = new google.maps.Marker({
                //     position: latLng,
                //     map: _that.mapPOI
                // });
                // google.maps.event.addListener(_that.mapPOI, 'center_changed', function () {
                //     var latlng = new google.maps.LatLng(parseFloat(_that.mapPOI.getCenter().lat()), parseFloat(_that.mapPOI.getCenter().lng()));
                //     _that.markerPOI.setPosition(latlng);
                // });
                _cb();
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (_poz) {
                        console.log(_poz.coords)
                        _lon = parseFloat(_poz.coords.longitude + '');
                        _lat = parseFloat(_poz.coords.latitude + '');
                        var latLng = new google.maps.LatLng(_lat, _lon);
                        _that.markerPOI.setPosition(latLng);
                        _that.pinMarker.setPosition(latLng);
                        _that.mapPOI.setCenter(latLng);
                        _that.mapPOI.setZoom(17);
                        _that.isMyPozOK = true
                        // let mapOptions = _that.getMapOptions()
                        // _that.mapPOI = new google.maps.Map(nativeElement, mapOptions);
                        // var latLng = new google.maps.LatLng(_lat, _lon);
                        // _that.mapPOI.setCenter(latLng);
                        // _that.mapPOI.setZoom(17);
                        // _that.markerPOI = new google.maps.Marker({
                        //     position: latLng,
                        //     map: _that.mapPOI
                        // });
                        // google.maps.event.addListener(_that.mapPOI, 'center_changed', function () {
                        //     var latlng = new google.maps.LatLng(parseFloat(_that.mapPOI.getCenter().lat()), parseFloat(_that.mapPOI.getCenter().lng()));
                        //     _that.markerPOI.setPosition(latlng);
                        // });
                        _cb();
                    }, function (_error) {
                        _that.isMyPozOK = false
                        console.log('Error getting location');
                        console.log(_error);

                        const toast = _that.pan.toastCtrl.create({
                            message: _that.pan.dic.l['locationserviceerror'],
                            duration: 3000,
                            position: 'top'
                        });
                        toast.present();

                        // let mapOptions = _that.getMapOptions()
                        // _that.mapPOI = new google.maps.Map(nativeElement, mapOptions);
                        // var latLng = new google.maps.LatLng(_lat, _lon);
                        // _that.mapPOI.setCenter(latLng);
                        // _that.mapPOI.setZoom(17);
                        // _that.markerPOI = new google.maps.Marker({
                        //     position: latLng,
                        //     map: _that.mapPOI
                        // });
                        // google.maps.event.addListener(_that.mapPOI, 'center_changed', function () {
                        //     var latlng = new google.maps.LatLng(parseFloat(_that.mapPOI.getCenter().lat()), parseFloat(_that.mapPOI.getCenter().lng()));
                        //     _that.markerPOI.setPosition(latlng);
                        // });
                        // _cb();
                    }, options);
                } else {
                    this.pan._Post("https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyDvzykDlkODU9QONJbbbCKKy-T6WwJgdrU", {}, function (_data) {
                        _lon = parseFloat(_data.location.lng);
                        _lat = parseFloat(_data.location.lat);
                        var latLng = new google.maps.LatLng(_lat, _lon);
                        _that.markerPOI.setPosition(latLng);
                        _that.pinMarker.setPosition(latLng);
                        _that.mapPOI.setCenter(latLng);
                        _that.mapPOI.setZoom(17);
                        _that.isMyPozOK = true
                        // let mapOptions = _that.getMapOptions()
                        // _that.mapPOI = new google.maps.Map(nativeElement, mapOptions);
                        // var latLng = new google.maps.LatLng(_lat, _lon);
                        // _that.mapPOI.setCenter(latLng);
                        // _that.mapPOI.setZoom(17);
                        // _that.markerPOI = new google.maps.Marker({
                        //     position: latLng,
                        //     map: _that.mapPOI
                        // });
                        // google.maps.event.addListener(_that.mapPOI, 'center_changed', function () {
                        //     var latlng = new google.maps.LatLng(parseFloat(_that.mapPOI.getCenter().lat()), parseFloat(_that.mapPOI.getCenter().lng()));
                        //     _that.markerPOI.setPosition(latlng);
                        // });
                        _cb();
                    })
                }
            }
        } else {
            console.log('IS APP')
            var _that = this
            this.geolocation.getCurrentPosition({ enableHighAccuracy: true }).then((resp) => {
                console.log('Vleze vo getCurrentPosition')
                // resp.coords.latitude
                // resp.coords.longitude
                _lon = parseFloat(resp.coords.longitude + '');
                _lat = parseFloat(resp.coords.latitude + '');
                var latLng = new google.maps.LatLng(_lat, _lon);
                _that.markerPOI.setPosition(latLng);
                _that.pinMarker.setPosition(latLng);
                _that.mapPOI.setCenter(latLng);
                _that.mapPOI.setZoom(17);
                _that.isMyPozOK = true

                if (_that.isPozWatching == false) {
                    _that.geolocation.watchPosition({ enableHighAccuracy: true }).subscribe(position => {
                        console.log('Vleze vo Watch position')
                        console.log(position)
                        if (position == null) { _that.isMyPozOK = false; return }
                        if (position.coords == null) { _that.isMyPozOK = false; return }
                        if (position.coords.longitude == null) { _that.isMyPozOK = false; return }
                        _that.isMyPozOK = true
                        _lon = parseFloat(position.coords.longitude + '');
                        _lat = parseFloat(position.coords.latitude + '');
                        var latLng = new google.maps.LatLng(_lat, _lon);
                        _that.markerPOI.setPosition(latLng);
                        //_that.mapPOI.setCenter(latLng);
                        _that.mapPOI.setZoom(17);
                    });
                    _that.isPozWatching = true
                }

                // let mapOptions = _that.getMapOptions()
                // _that.mapPOI = new google.maps.Map(nativeElement, mapOptions);
                // var latLng = new google.maps.LatLng(_lat, _lon);
                // _that.mapPOI.setCenter(latLng);
                // _that.mapPOI.setZoom(17);
                // _that.markerPOI = new google.maps.Marker({
                //     position: latLng,
                //     map: _that.mapPOI
                // });
                // google.maps.event.addListener(_that.mapPOI, 'center_changed', function () {
                //     var latlng = new google.maps.LatLng(parseFloat(_that.mapPOI.getCenter().lat()), parseFloat(_that.mapPOI.getCenter().lng()));
                //     _that.markerPOI.setPosition(latlng);
                // });
                _cb();
            }).catch((error) => {
                _that.isMyPozOK = false
                console.log('Error getting location');
                console.log(error);

                const toast = _that.pan.toastCtrl.create({
                    message: _that.pan.dic.l['locationserviceerror'],
                    duration: 3000,
                    position: 'top'
                });
                toast.present();

                // console.log(error)
                // let mapOptions = _that.getMapOptions()
                // _that.mapPOI = new google.maps.Map(nativeElement, mapOptions);
                // var latLng = new google.maps.LatLng(_lat, _lon);
                // _that.mapPOI.setCenter(latLng);
                // _that.mapPOI.setZoom(17);
                // _that.markerPOI = new google.maps.Marker({
                //     position: latLng,
                //     map: _that.mapPOI
                // });
                // google.maps.event.addListener(_that.mapPOI, 'center_changed', function () {
                //     var latlng = new google.maps.LatLng(parseFloat(_that.mapPOI.getCenter().lat()), parseFloat(_that.mapPOI.getCenter().lng()));
                //     _that.markerPOI.setPosition(latlng);
                // });
                // _cb();
                // //console.log('Error getting location', error);
            });


        }

        // } else {
        //     //x.innerHTML = "Geolocation is not supported by this browser.";
        //     console.log("Geolocation is not supported by this browser.")
        // }

    }

    drawCircle(radius: any) {

        if (this.circlePOI != null) {
            this.circlePOI.setMap(null);
            this.circlePOI = null;
        }
        this.circlePOI = new google.maps.Circle({
            map: this.mapPOI,
            radius: radius,    // 10 miles in metres
            fillColor: '#AA0000',
            strokeColor: "#AA0000",
            strokeOpacity: 0.55,
            strokeWeight: 1
        });
        this.circlePOI.bindTo('center', this.markerPOI, 'position');
    }

    drawCircle1(radius: any) {

        if (this.circlePOI != null) {
            this.circlePOI.setMap(null);
            this.circlePOI = null;
        }
        this.circlePOI = new google.maps.Circle({
            map: this.mapPOI,
            radius: radius,    // 10 miles in metres
            fillColor: '#AA0000',
            strokeColor: "#AA0000",
            strokeOpacity: 0.55,
            strokeWeight: 1
        });
        this.circlePOI.bindTo('center', this.pinMarker, 'position');
    }

    // getAllVehicles(clientid: any, _callback) {
    //     var _that = this;
    //     _that.pan._Post('/api/vehiclesByRoleID/', {
    //         roleid: this.pan.RoleId,
    //         clientid: this.pan.ClientId,
    //         userid: this.pan.UserId
    //     }, function (_data) {
    //         var data1 = _data.data1 //od procedura
    //         var data2 = _data.data2 //od tabela site vozila
    //         // console.log()
    //         console.log(data1, data2)
    //         _that.vehicles = <any>_that.pan.parseVehiclesData(data1[0].getcpforfirstws.split("#"), data2);
    //         // _that.vehicles = data2;
    //         // console.log(_that.vehicles)
    //         // for (let i = 0; i < data1[0].getcpforfirstws.split("#").length; i++) {
    //         //     console.log(data1[0].getcpforfirstws.split("#")[i])
    //         //     for (let k = 0; k < _that.vehicles.length; k++) {
    //         //         if(data1[0].getcpforfirstws.split("#")[i].split('|')[0] == _that.vehicles[k].code){
    //         //             _that.vehicles = <any>_that.parseData(data1[0].getcpforfirstws.split("#")[i])
    //         //         }

    //         //     }
    //         // }
    //         console.log('vozila',_that.vehicles)
    //         _callback();
    //     })
    // }

    loadInitVehicles(_cb) {
        var _that = this
        // console.log(this.pan.Colors)
        this.pan._Post('/api/gn/vehiclesByRoleID/', { roleid: this.pan.user.RoleId, clientid: this.pan.user.ClientId, userid: this.pan.user.UserId }, function (_data) {
            // console.log(_data.data2)
            var _d = _data.data1[0].getcpforfirstws
            var arr = _d.split('#')
            var _visVeh = 0
            for (var i = 1; i < arr.length; i++) {
                var v = _that.parseData(arr[i])

                _that.VehiclesDic[v.vehicleid] = _that.vehicles.length

                for (var j = 0; j < _data.data2.length; j++) {
                    if (_data.data2[j].vehicleid + '' == v.vehicleid + '') {
                        // console.log('TUKAAA')
                        // console.log(_data.data2[j])
                        // console.log(_data.data2[j].organisationid)
                        //v.driverdest = _data.data2[j].driverdest
                        v.nopay = _data.data2[j].nopay
                        v.lastpaydt = _data.data2[j].lastpaydt == '/' ? '/' : moment(_data.data2[j].lastpaydt).format(_that.pan.user.DFormat + ' ' + _that.pan.user.TFormat)

                        if (v.nopay == '1') {
                            v.color = 'Gray'
                            v.datumformated = v.lastpaydt
                        }

                        v.roaddirection = _data.data2[j].roaddirection
                        v.orgcolor = ''
                        v.visible = _data.data2[j].visible
                        v.organisationid = _data.data2[j].organisationid
                        v.consumptionbyhour = _data.data2[j].consumptionbyhour
                        v.brand = _data.data2[j].brand
                        v.armed = _data.data2[j].armed

                        v.multiplefueltypes = _data.data2[j].multiplefueltypes
                        v.approve = _data.data2[j].approve
                        v.suspend = _data.data2[j].suspend

                        v.typeid = _data.data2[j].typeid
                        v.printtravelorder = _data.data2[j].printtravelorder
                        v.alias = _data.data2[j].alias
                        v.model = _data.data2[j].model
                        v.albletemp = _data.data2[j].albletemp
                        v.alrpm = _data.data2[j].alrpm
                        v.showrpm = _data.data2[j].showrpm
                        v.driver = _data.data2[j].driver
                        v.altemp = _data.data2[j].altemp
                        v.alfuel = _data.data2[j].alfuel
                        v.fuel = _data.data2[j].fuel
                        //v.ufuel = _data.data2[j].ufuel
                        v.alcanbas = _data.data2[j].alcanbas
                        v.engineworktimetype = _data.data2[j].engineworktimetype
                        // v.AllowCANbus = _data.data2[j].AllowCANbus
                        v.a_cbd = _data.data2[j].a_cbd
                        v.a_cbr = _data.data2[j].a_cbr
                        v.a_cbf = _data.data2[j].a_cbf
                        v.a_cbt = _data.data2[j].a_cbt

                        v.speedlimitalertallow = _data.data2[j].speedlimitalertallow
                        v.allowdraeger = _data.data2[j].allowdraeger

                        v.dashboard = false

                        v.slot1name = _data.data2[j].slot1name
                        v.a_bletemp1 = _data.data2[j].allowbletemp1
                        v.a_blehumidity1 = _data.data2[j].allowblehumidity1
                        v.a_blebattery1 = _data.data2[j].allowblebattery1

                        v.slot2name = _data.data2[j].slot2name
                        v.a_bletemp2 = _data.data2[j].allowbletemp2
                        v.a_blehumidity2 = _data.data2[j].allowblehumidity2
                        v.a_blebattery2 = _data.data2[j].allowblebattery2

                        v.slot3name = _data.data2[j].slot3name
                        v.a_bletemp3 = _data.data2[j].allowbletemp3
                        v.a_blehumidity3 = _data.data2[j].allowblehumidity3
                        v.a_blebattery3 = _data.data2[j].allowblebattery3

                        v.slot4name = _data.data2[j].slot4name
                        v.a_bletemp4 = _data.data2[j].allowbletemp4
                        v.a_blehumidity4 = _data.data2[j].allowblehumidity4
                        v.a_blebattery4 = _data.data2[j].allowblebattery4

                        v.allowbattery = _data.data2[j].allowbattery
                        v.allowultrasonic = _data.data2[j].allowultrasonic
                        v.allowgarmin = _data.data2[j].allowgarmin
                        v.allowengineblock = _data.data2[j].allowengineblock

                        v.zonenames = _data.data2[j].zonenames
                        v.poinames = _data.data2[j].poinames
                        // v.equipment = _data.data2[j].equipment


                        var _AllowedPKSABH = '0'
                        if (_data.data2[j].prednavrata != '-' || _data.data2[j].zadnavrata != '-' || _data.data2[j].hauba != '-' || _data.data2[j].kapaci != '-' || _data.data2[j].pumpa != '-' || _data.data2[j].sovozac != '-' || _data.data2[j].digalka != '-' || _data.data2[j].allowbattery + '' == '1' || _data.data2[j].allowinputvoltage + '' == '1') {
                            _AllowedPKSABH = '1'
                        }
                        v._AllowedPKSABH = _AllowedPKSABH
                        v._AllowedSovozac = _data.data2[j].sovozac

                        var _AllowSTP = '1'
                        if (_that.pan.user.speed != '1' && _that.pan.user.taximeter != '1' && _that.pan.user.passengers != '1') {
                            _AllowSTP = '0'
                        }
                        v._AllowSTP = _AllowSTP
                        // console.log(_data.data2[j])
                    }
                }
                if (v.visible == '1') { _visVeh = _visVeh + 1 }
                // console.log("CANBAS: "+v.alcanbas+"RPM: "+v.a_cbr);
                // console.log(v);
                _that.vehicles.push(v)
            }

            // console.log(_that.vehicles)
            // for (var i=0; i< _data.data2.length; i++){

            // }
            // console.log(_d)
            // for (var i=0; i<_data.data1.length; i++){

            // }
            // console.log(_visVeh)
            // console.log(_data.data2)
            // console.log(_that.gn.Vehicles)
            _cb()
        })

    }

    addMarker(_label, _lon, _lat, vehid, ignition = '', status = false, color) {
        var _that = this;
        var el = document.createElement("DIV");
        el.className = "gn-ol-market" + this.pan.user.vehsize + " gn-car-" + color
        el.innerHTML = '<span style="z-index:1; position: relative">' + _label + '</span><span class="gn-nouse' + this.pan.user.vehsize + '"></span>'
        el.setAttribute('car-code', _label)
        el.setAttribute('id', 'gncar-' + _label)

        var marker = new RichMarker({
            position: new google.maps.LatLng(_lat, _lon),
            draggable: false,
            content: el.outerHTML,
            flat: true,
            anchor: RichMarkerPosition.MIDDLE,
            code: _label,
            vehid: vehid

        });
        return marker

    }
    setCenter(_lon, _lat) {
        this.mapLive.panTo(new google.maps.LatLng(_lat, _lon));
    }
    setZoom(_zoom) {
        this.mapLive.setZoom(_zoom)
    }
    centerMapToVehicle(_code, _lon, _lat) {
        this.setCenter(parseFloat(_lon), parseFloat(_lat))
        this.setZoom(16)
        var topka = <HTMLElement>document.getElementById('gncar-' + _code)
        if (topka != null) {
            topka.classList.add('gn-ol-market' + this.pan.user.vehsize + '-anim')
            topka.style.zIndex = '3'
            setTimeout(function () {
                topka.classList.remove('gn-ol-market' + this.pan.user.vehsize + '-anim')
            }, 8 * 1000)
        }
    }

    sortFunction(a, b) {
        var dateA = new Date(a.dtzone).getTime();
        var dateB = new Date(b.dtzone).getTime();
        return dateA > dateB ? 1 : -1;
    };

    parseData(_data) {
        var dat = _data.split('|')
        if (dat.length < 30) {
            return
        }
        var Vehicle = {
            showDetails: false,
            showDetailsIcon: 'ios-arrow-dropright-outline',
            code: dat[0],
            lon: parseFloat(dat[1]),
            lat: parseFloat(dat[2]),
            _status: dat[3],
            passive: dat[4],
            datum: dat[5],
            datumformated: '',
            location: dat[6],
            taxi: dat[8],
            sedista: dat[9],
            olddate: dat[10],
            olddate15: dat[45],
            portai4: (dat[93] != 'undefined' && dat[93] != undefined && dat[93] != null && dat[93] != '') ? dat[93] : 0,
            engineworktime: (dat[94] != 'undefined' && dat[94] != undefined && dat[94] != null && dat[94] != '') ? dat[94] : 0,
            engineworktimemanual: (dat[95] != 'undefined' && dat[95] != undefined && dat[95] != null && dat[95] != '') ? this.sec2str2(dat[95] * 3600) : 0,
            address: dat[11],
            gis: dat[12],
            registration: dat[13],
            alarm: dat[14],
            fulldt: dat[15],
            cbfuel: dat[16],
            cbrpm: dat[17],
            cbtemp: dat[18],
            cbdistance: dat[19],
            temperature: dat[20],
            roomtemperature: dat[56],
            litres: dat[21],
            ufuel: dat[39],
            zoneids: dat[22],
            odometar: dat[23],
            service: dat[24],
            status: dat[25],
            zonedt: dat[26],
            vehicleid: dat[27],
            ignition: dat[28],
            kapaci: dat[29],
            pumpa: dat[30],
            rpm: dat[31],
            driver: dat[32],
            sopatnik: dat[33],
            gsmnum: dat[34],
            engineblock: dat[35],
            doorstatus: dat[102], //can control
            enginestatus: dat[103], //can control
            battery: dat[36],
            inputvoltage: dat[38] == '-2' ? this.pan.dic.l["fAccumulator"] : (dat[38].indexOf('-1:::') != '-1' ? ('' + this.pan.dic.l["weakAccumulator"] + ' (' + parseFloat(dat[38].split(':::')[1]).toFixed(2) + ' V)') : (dat[38] == '/' ? dat[38] : parseFloat(dat[38]).toFixed(2) + ' V')),
            ultrasonic: dat[39],
            digalka: dat[40],

            prednavrata: (dat[58] != undefined) ? parseInt(dat[58]) : -1,
            zadnavrata: (dat[59] != undefined) ? parseInt(dat[59]) : -1,
            hauba: (dat[67] != undefined) ? parseInt(dat[67]) : -1,

            fuelpulses: dat[69] == -1 ? -1 : parseFloat(dat[69]),
            fuelpulsesveh: dat[96],
            saldo: dat[97],

            lastgeneratordata: dat[98],
            lastgeneratordata1: '',
            lastgeneratordata2: '',
            lastgeneratordata3: (dat[98] != 'undefined' && dat[98] != undefined && dat[98] != null && dat[98] != '') ? (parseFloat(dat[98].split('~')[2]) <= 0 ? '/' : dat[98].split('~')[2]) : '/',

            generatorengine: dat[65],
            generatornextservice: dat[99],

            idlestatusminutes: (dat[105] != 'undefined' && dat[105] != undefined && dat[105] != null && dat[105] != '') ? dat[105] : 0,

            lastdraegerdata_date: (dat[110] != 'undefined' && dat[110] != undefined && dat[110] != null && dat[110] != 'null' && dat[110] != '/') ? moment(dat[110].split('&&&')[0]).format(this.pan.user.DFormat) : '/',
            lastdraegerdata_time: (dat[110] != 'undefined' && dat[110] != undefined && dat[110] != null && dat[110] != 'null' && dat[110] != '/') ? moment(dat[110].split('&&&')[0]).format(this.pan.user.TFormat) : '/',
            lastdraegerdata_val: (dat[110] != 'undefined' && dat[110] != undefined && dat[110] != null && dat[110] != 'null' && dat[110] != '/') ? parseFloat(dat[110].split('&&&')[1]).toFixed(3) : 0,


            digalkaanalog: (dat[100] != 'undefined' && dat[100] != undefined && dat[100] != null && dat[100] != '') ? dat[100] : '0',

            //ocena live
            // dscore: '/',
            // nscore: '/',
            // mscore: '/',
            dscore: (dat[101] != 'undefined' && dat[101] != undefined && dat[101] != null && dat[101] != '') ? dat[101].split('^')[0] : '/',
            nscore: (dat[101] != 'undefined' && dat[101] != undefined && dat[101] != null && dat[101] != '') ? dat[101].split('^')[1] : '/',
            mscore: (dat[101] != 'undefined' && dat[101] != undefined && dat[101] != null && dat[101] != '') ? dat[101].split('^')[2] : '/',
            // didscore: (dat[101] != 'undefined' && dat[101] != undefined && dat[101] != null && dat[101] != '') ? dat[101].split('^')[3] : '/',
            //end ocena live

            bletemp1: (dat[71] != '//' && dat[71] != 'undefined' && dat[71] != undefined && dat[71] != null && dat[71] != '') ? (((parseFloat(dat[71]) * 100) / 100) + ` °` + this.pan.user.tempunit) : '/',
            bletemp2: (dat[79] != '//' && dat[79] != 'undefined' && dat[79] != undefined && dat[79] != null && dat[79] != '') ? (((parseFloat(dat[79]) * 100) / 100) + ` °` + this.pan.user.tempunit) : '/',
            bletemp3: (dat[80] != '//' && dat[80] != 'undefined' && dat[80] != undefined && dat[80] != null && dat[80] != '') ? (((parseFloat(dat[80]) * 100) / 100) + ` °` + this.pan.user.tempunit) : '/',
            bletemp4: (dat[81] != '//' && dat[81] != 'undefined' && dat[81] != undefined && dat[81] != null && dat[81] != '') ? (((parseFloat(dat[81]) * 100) / 100) + ` °` + this.pan.user.tempunit) : '/',
            blehumidity1: (dat[82] != '//' && dat[82] != 'undefined' && dat[82] != undefined && dat[82] != null && dat[82] != '') ? (((parseFloat(dat[82]) * 100) / 100) + ' %') : '/',
            blehumidity2: (dat[83] != '//' && dat[83] != 'undefined' && dat[83] != undefined && dat[83] != null && dat[83] != '') ? (((parseFloat(dat[83]) * 100) / 100) + ' %') : '/',
            blehumidity3: (dat[84] != '//' && dat[84] != 'undefined' && dat[84] != undefined && dat[84] != null && dat[84] != '') ? (((parseFloat(dat[84]) * 100) / 100) + ' %') : '/',
            blehumidity4: (dat[85] != '//' && dat[85] != 'undefined' && dat[85] != undefined && dat[85] != null && dat[85] != '') ? (((parseFloat(dat[85]) * 100) / 100) + ' %') : '/',

            towstatus: (dat[86] != undefined) ? parseInt(dat[86]) : -1,
            lastbeacon: (dat[87] != undefined && dat[87] != null && dat[87] != '') ? (dat[87]).split('~')[2] : '/',
            ekipa: (dat[88] != undefined && dat[88] != null && dat[88] != '') ? dat[88] : '/',

            batcharging: (dat[89] != 'undefined' && dat[89] != undefined && dat[89] != null && dat[89] != '') ? dat[89] : '0',
            chargingcable: (dat[90] != 'undefined' && dat[90] != undefined && dat[90] != null && dat[90] != '') ? dat[90] : '0',
            electricbat: (dat[91] != 'undefined' && dat[91] != undefined && dat[91] != null && dat[91] != '') ? dat[91] : '0',

            portdi2: (dat[92] != 'undefined' && dat[92] != undefined && dat[92] != null && dat[92] != '') ? dat[92] : '0',

            routedetails: (dat[72] != undefined) ? dat[72] : '-1',
            mixerstatus: (dat[73] != '' && dat[73] != undefined) ? dat[73].replace(/ /g, '').substring(0, 1) : '/',

            frontr: (dat[74] != undefined) ? parseInt(dat[74]) : -1,
            frontl: (dat[75] != undefined) ? parseInt(dat[75]) : -1,
            stranichna: (dat[76] != undefined) ? ((parseFloat(dat[76]) != -1) ? (parseFloat(dat[76]) > 12 ? 1 : 0) : -1) : -1,

            d1timerelstate: (dat[77] != undefined) ? parseFloat(dat[77]) : -1,
            d2timerelstate: (dat[78] != undefined) ? parseFloat(dat[78]) : -1,

            lostcomm: 0,
            lostcomm15: 0,
            // weather: dat[41].split('@@@')
            speedNumber: 0,
            speed: '', sofer: '', leftdoor: '', rightdoor: '', overside: '', reardoor: '',
            driverdest: '', endlocation: '/', statusign: dat[28], roaddirection: '', nopay: '0', lastpaydt: '/', geolock: '', radius: '',
            noconnection: false, noconnection15: true, color: '', visible: '0', tmpVisible: true,
            orgcolor: '',
            organisationid: 0,
            consumptionbyhour: '0',
            brand: '',
            armed: '0',

            multiplefueltypes: '0',
            approve: 2,
            suspend: '1',

            typeid: 1,
            printtravelorder: '',
            alias: '', model: '', albletemp: 0, alrpm: 0, showrpm: '', altemp: 0, alfuel: 0, fuel: 0.0, allowultrasonic: 0,
            allowgarmin: '0', allowengineblock: '0',
            /*ufuel: 0.00,*/
            alcanbas: 0, engineworktimetype: '', AllowCANbus: 0, a_cbd: 0, a_cbr: 0, a_cbf: 0, a_cbt: 0, speedlimitalertallow: 0, allowdraeger: 0, dashboard: false, slot1name: this.pan.dic.l["slot"] + '1', a_bletemp1: 0, a_blehumidity1: 0, a_blebattery1: 0, slot2name: this.pan.dic.l["slot"] + '2', a_bletemp2: 0, a_blehumidity2: 0, a_blebattery2: 0, slot3name: this.pan.dic.l["slot"] + '3', a_bletemp3: 0, a_blehumidity3: 0, a_blebattery3: 0, slot4name: this.pan.dic.l["slot"] + '4', a_bletemp4: 0, a_blehumidity4: 0, a_blebattery4: 0, _AllowedPKSABH: '0', allowbattery: 0, _AllowSTP: '0', zonenames: dat[11], poinames: '',
            searchVisible: true, _AllowedSovozac: '-',
            // equipment: ''
            //,col5: dat[69] == undefined ? -1 : dat[69]
        }
        // console.log(Vehicle.datum)

        if (this.pan.isNumeric(Vehicle.cbrpm)) {
            Vehicle.cbrpm = parseInt(Vehicle.cbrpm)
            if (Vehicle.ignition + '' == '0') {
                Vehicle.cbrpm = 0
            }
        }

        if (this.pan.isNumeric(Vehicle.cbtemp)) {
            Vehicle.cbtemp = parseInt(Vehicle.cbtemp)
            if (Vehicle.ignition + '' == '0') {
                Vehicle.cbtemp = 0
            }
        }

        if (this.pan.isNumeric(Vehicle.cbfuel)) {
            Vehicle.cbfuel = parseInt(Vehicle.cbfuel)
            // if (Vehicle.ignition+''=='0'){
            //     Vehicle.cbrpm = 0
            // }
        }
        //cbfuel

        //Vehicle.datumformated = moment(Vehicle.datum, "DD-MM-YYYY HH:mm:ss").format(this.pan.user.DFormat) + ' ' + moment(Vehicle.datum, "DD-MM-YYYY HH:mm:ss").format(this.pan.user.TFormat)
        Vehicle.datumformated = moment(Vehicle.fulldt).format(this.pan.user.DFormat + ' ' + this.pan.user.TFormat)

        if (Vehicle.lastgeneratordata != 'undefined' && Vehicle.lastgeneratordata != undefined && Vehicle.lastgeneratordata != null && Vehicle.lastgeneratordata != '') {
            Vehicle.lastgeneratordata1 = Vehicle.lastgeneratordata == '' ? '/' : moment(Vehicle.lastgeneratordata.split('~')[0]).format(this.pan.user.DFormat + ' ' + this.pan.user.TFormat)
            Vehicle.lastgeneratordata2 = Vehicle.lastgeneratordata == '' ? '/' : this.sec2str2(Vehicle.lastgeneratordata.split('~')[1])
        }

        // console.log(dat[7])
        if (Vehicle.ignition == '1') Vehicle.statusign = '2';
        if (Vehicle.ignition == '1' && Vehicle.idlestatusminutes > this.pan.user.idleover) Vehicle.statusign = '1';

        Vehicle.speedNumber = dat[7]
        if (dat[7] == '/') {
            Vehicle.speed = '/'
        } else {
            Vehicle.speed = parseInt(dat[7], 10) + ' Km/h';
        }
        if (this.pan.user.metric.toLowerCase() != 'km') {
            Vehicle.speed = Math.round(Math.round((parseFloat(dat[7]) * 0.621371) * 100) / 100) + ' mph';
            Vehicle.odometar = Math.round(dat[23] * 0.621371);
            Vehicle.service = Math.round(dat[24] * 0.621371);
            Vehicle.cbdistance = Math.round(dat[19] * 0.621371);

        }
        if (dat[60] == '-1' || dat[60] == undefined) {
            Vehicle.sofer = '/'
        } else {
            if (dat[60] == '1') {
                Vehicle.sofer = 'sit';
            } else {
                Vehicle.sofer = 'stand';
            }
        }

        if (parseInt(dat[58], 10) == -1 || dat[58] == undefined || parseInt(dat[58], 10) == 0) {
            Vehicle.leftdoor = '/';
            Vehicle.rightdoor = '/';
        } else
            if (parseFloat(dat[58]) <= 9.7) {
                Vehicle.leftdoor = 'open';
                Vehicle.rightdoor = 'open';
            } else
                if (parseFloat(dat[58]) > 9.7 && parseFloat(dat[58]) <= 14.5) {
                    Vehicle.leftdoor = 'close';
                    Vehicle.rightdoor = 'open';
                } else
                    if (parseFloat(dat[58]) > 14.5 && parseFloat(dat[58]) <= 20) {
                        Vehicle.leftdoor = 'open';
                        Vehicle.rightdoor = 'close';
                    } else
                        if (parseFloat(dat[58]) > 20) {
                            Vehicle.leftdoor = 'close';
                            Vehicle.rightdoor = 'close';
                        }

        if (parseInt(dat[59], 10) == -1 || dat[59] == undefined || parseInt(dat[59], 10) == 0) {
            Vehicle.overside = '/';
            Vehicle.reardoor = '/';
        } else
            if (parseFloat(dat[59]) <= 11.5) {
                Vehicle.overside = 'open';
                Vehicle.reardoor = 'open';
            } else
                if (parseFloat(dat[59]) > 11.5 && parseFloat(dat[59]) <= 15) {
                    Vehicle.overside = 'close';
                    Vehicle.reardoor = 'open';
                } else
                    if (parseFloat(dat[59]) > 15 && parseFloat(dat[59]) <= 20) {
                        Vehicle.overside = 'open';
                        Vehicle.reardoor = 'close';
                    } else
                        if (parseFloat(dat[59]) > 20) {
                            Vehicle.overside = 'close';
                            Vehicle.reardoor = 'close';
                        }

        Vehicle.driverdest = dat[42];
        if (Vehicle.driverdest != '/') {
            Vehicle.driverdest = Vehicle.driverdest.split('@')[0]
            if (Vehicle.driverdest == '') {
                Vehicle.driverdest = Vehicle.driverdest.split('@')[1] + ', ' + Vehicle.driverdest.split('@')[2]
            }
        }

        //START EndLocation
        if (Vehicle.routedetails != '-1' && Vehicle.routedetails.split('@')[0] + '' == '1') {
            var rr = Vehicle.routedetails.split('@')[1].split('/')

            var nextpoi = '/'
            if (rr[0] != rr[1] || rr[0] + '' == '0') {
                nextpoi = Vehicle.routedetails.split('@')[2]
            }
            Vehicle.endlocation = nextpoi;
        }
        if (Vehicle.driverdest != '/') {
            if (Vehicle.endlocation != '/') {
                Vehicle.endlocation += '; ' + Vehicle.driverdest;
            }
            Vehicle.endlocation += Vehicle.driverdest;
        }
        //END EndLocation

        // var tmpa = dat[37]
        // if (tmpa==null){tmpa='0'}
        // if (dat[37] == "0") {
        //     Vehicle.geolock = "0";
        //     Vehicle.radius = "0";
        // } else {
        //     Vehicle.geolock = dat[37].split("-")[0];
        //     Vehicle.radius = dat[37].split("-")[1];
        // }
        //console.log(Vehicle)
        if (Vehicle.ignition == '1' && Vehicle.olddate == '1')
            Vehicle.noconnection = true;
        else
            Vehicle.noconnection = false;

        if (this.pan.clientsettings.indoor > 0) {
            if (Vehicle.olddate == '1')
                Vehicle.noconnection = true;
            else
                Vehicle.noconnection = false;
        }

        if (Vehicle.ignition == '1' && Vehicle.olddate15 == '1')
            Vehicle.noconnection15 = true;
        else
            Vehicle.noconnection15 = false;
        if (this.pan.clientsettings.indoor > 0) {
            if (Vehicle.olddate15 == '1')
                Vehicle.noconnection15 = true;
            else
                Vehicle.noconnection15 = false;
        }

        Vehicle.color = 'Gray'
        var _sedista = 0

        if (this.pan.isNumeric(Vehicle.sedista)) {
            _sedista = parseInt(Vehicle.sedista)
        }
        if (Vehicle.ignition == '0' && _sedista == 0) {
            Vehicle.color = this.pan.Colors.engineoff
        }
        if (Vehicle.ignition == '0' && _sedista > 0) {
            Vehicle.color = this.pan.Colors.engineoffpassengeron
        }
        if (Vehicle.ignition == '1' && _sedista > 0 && Vehicle.taxi == '0') {
            Vehicle.color = this.pan.Colors.taximeteroffpassengeron
        }
        if (Vehicle.ignition == '1' && Vehicle.taxi == '1') {
            Vehicle.color = this.pan.Colors.taximeteron
        }
        if (Vehicle.ignition == '1' && _sedista == 0 && Vehicle.taxi == '0') {
            Vehicle.color = this.pan.Colors.engineon
        }
        if (Vehicle.passive == '1') {
            Vehicle.color = this.pan.Colors.passiveon
        }
        if (Vehicle.ignition == '1' && Vehicle.olddate == '1') {
            Vehicle.color = 'Gray'
            //todo
            Vehicle.lostcomm = 1
        } else {
            //todo
            Vehicle.lostcomm = 0
        }
        if (this.pan.clientsettings.indoor > 0) {
            if (Vehicle.olddate == '1') {
                Vehicle.color = 'Gray'
                //todo
                Vehicle.lostcomm = 1
            } else {
                //todo
                Vehicle.lostcomm = 0
            }
        }


        if (Vehicle.nopay == '1') {
            Vehicle.color = 'Gray'
            Vehicle.datumformated = Vehicle.lastpaydt
        }

        if (Vehicle.ignition == '1' && Vehicle.olddate15 == '1') {
            Vehicle.lostcomm15 = 1
        } else {
            Vehicle.lostcomm15 = 0
        }
        if (this.pan.clientsettings.indoor > 0) {
            if (Vehicle.olddate15 == '1') {
                Vehicle.lostcomm15 = 1
            } else {
                Vehicle.lostcomm15 = 0
            }
        }

        return Vehicle
    }


    moveMarker2(_idx, newLon, newLat, _code, _angle) {


        if (this.socketEnable == false) { return }
        if (this.VehicleAnim.length == 0) { return }


        this.markers[_idx].setPosition(new google.maps.LatLng(newLat, newLon))

        var topka = document.getElementById('gncar-' + _code)
        if (topka != null) {
            topka.setAttribute('angle', "yes")
            var elnose = <HTMLElement>topka.getElementsByClassName('gn-nouse' + this.pan.user.vehsize)[0]
            elnose.style.transform = 'rotate(' + _angle + 'deg)'
        }

    }


    sec2str2(_sec) {
        if (_sec >= 0) {
            var str = '';
            var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
            var m = moment.utc(_sec * 1000).format('m');
            var s = moment.utc(_sec * 1000).format('s');
            if (_sec < 60) {
                str = s + this.pan.dic.l["sec"];
            }
            else {
                if (_sec < 3600) {
                    str = m + this.pan.dic.l["min"]
                }
                else {
                    str = h + this.pan.dic.l["h"] + ' ' + m + this.pan.dic.l["min"]
                }
            }
            return str;
        }
        else {
            return '-1';
        }
    }

    moveVehicle(_code, _lon, _lat) {
        // if (this.pan.mapPage == null) { return }
        for (var i = 0; i < this.VehicleAnim.length; i++) {
            var m = this.VehicleAnim[i]
            if (m.code == _code) {
                // for (var j = 0; j < this.pan.VehicleAnim[i].anim.length; j++) {
                //     clearTimeout(this.pan.VehicleAnim[i].anim[j]);
                // }
                var duration = 3000.0
                var speed = 30.0
                var dX = (_lon - m.lon) / speed
                var dY = (_lat - m.lat) / speed
                var dT = duration / speed
                var tim = dT

                var p1 = ol.proj.transform([this.VehicleAnim[i].lon, this.VehicleAnim[i].lat], 'EPSG:4326', 'EPSG:900913')
                var p2 = ol.proj.transform([_lon, _lat], 'EPSG:4326', 'EPSG:900913')

                var ddX = p2[0] - p1[0];
                var ddY = p2[1] - p1[1];
                var alfa = Math.round(Math.atan2(ddY * 1.0, ddX * 1.0) * (180.0 / Math.PI));
                alfa = 0 - alfa

                var topka = document.getElementById('gncar-' + _code)
                if (topka != null) {
                    topka.setAttribute('angle', "yes")
                    var elnose = <HTMLElement>topka.getElementsByClassName('gn-nouse' + this.pan.user.vehsize)[0]
                    elnose.style.transform = 'rotate(' + alfa + 'deg)'
                }
                var _that = this
                var distance = this.distance(m.lon, m.lat, _lon, _lat)
                if (distance > 500) {
                    _that.moveMarker2(i, _lon, _lat, _code, alfa)
                } else {
                    for (var j = 0; j < speed; j++) {
                        tim = tim + dT
                        if (this.VehicleAnim[i].anim.length > 30)
                            this.VehicleAnim[i].anim = []
                        this.VehicleAnim[i].anim.push({ angle: alfa, lon: (m.lon + (dX * j)), lat: (m.lat + (dY * j)) })
                    }
                }
                this.VehicleAnim[i].lon = _lon
                this.VehicleAnim[i].lat = _lat
                break;
            }
        }
    }

    distance(x1, y1, x2, y2) {
        var length = 0;
        var wgs84Sphere = new ol.Sphere(6378137);
        length += wgs84Sphere.haversineDistance([x1, y1], [x2, y2]);
        // console.log(length)
        return length;
    }

    setVehicleColor(_code, _color, _veh, _tf) {
        var obj = document.getElementById('gncar-' + _code)

        if (obj != null) {
            if (obj.className.indexOf('gn-ol-market' + this.pan.user.vehsize + '-anim') > -1) {
                obj.className = "gn-ol-market" + this.pan.user.vehsize + " gn-ol-market" + this.pan.user.vehsize + "-anim gn-car-" + _color
            } else {
                obj.className = "gn-ol-market" + this.pan.user.vehsize + " gn-car-" + _color
            }
            if (_veh.orgcolor != '')
                obj.style.border = "5px solid " + _veh.orgcolor
            obj.style.boxSizing = "content-box"
            obj.style.boxShadow = "0px 0px 10px #000"



            //debugger;
            if (document.getElementById('gncarimg01-' + _code) != undefined) {
                var _dimg01 = 'none';
                var _dimg02 = 'none';
                var _dimg03 = 'none';
                if ((_veh.lostcomm + '' == '1' || _veh.lostcomm15 + '' == '1') && _veh.status + '' == '1') {
                    _dimg01 = 'block';
                }
                if (_veh.status + '' == '0' && _veh.lostcomm + '' == '0' && _veh.lostcomm15 + '' == '0') {
                    _dimg02 = 'block';
                }
                if ((_veh.lostcomm + '' == '1' || _veh.lostcomm15 + '' == '1') && _veh.status + '' == '0') {
                    _dimg03 = 'block';
                }
                document.getElementById('gncarimg01-' + _code).style.display = _dimg01;
                document.getElementById('gncarimg02-' + _code).style.display = _dimg02;
                document.getElementById('gncarimg03-' + _code).style.display = _dimg03;
            }
        }
    }


    startVehiclesMoving() {
        // console.log('Tuka sme')
        if (this.moveInterval == null) {
            this.isInInterval = false
            var _that = this
            this.moveInterval = setInterval(function () {
                _that.intervalUnderMouse += 1
                if (_that.intervalUnderMouse == 20) {
                    _that.intervalUnderMouse = 0
                    _that.timerUnderMouse()
                }
                if (_that.isInInterval == false) {
                    // console.log('vo interval '+new Date())
                    _that.isInInterval = true
                    for (var i = 0; i < _that.VehicleAnim.length; i++) {
                        if (_that.VehicleAnim[i].anim.length > 0) {
                            var poz = _that.VehicleAnim[i].anim[0]
                            _that.VehicleAnim[i].anim.splice(0, 1)
                            _that.moveMarker2(i, poz.lon, poz.lat, _that.VehicleAnim[i].code, poz.angle)
                        }
                    }

                    _that.isInInterval = false
                }
            }, 50)
        }
    }
    stopVehiclesMoving() {
        this.isInInterval = false
        if (this.moveInterval != null) {
            clearInterval(this.moveInterval)
            this.moveInterval = null
        }
    }

    timerUnderMouse() {
        //map-undermouse-popup
        // console.log('vleze ovde upm')
        var el = document.getElementById('map-undermouse-popup')
        if (el != null) {
            var tmr = parseInt(el.getAttribute('gtimer'))//parseInt($('#map-undermouse-popup').attr('gtimer'))
            if (tmr > 0) {
                tmr = tmr - 1
                el.setAttribute('gtimer', tmr + '')
            }
        }

    }
}


// WEBPACK FOOTER //
// ./src/pan.maps.ts